import { useEffect, useRef } from 'react';

export default function CustomCursor() {
  const cursorRef = useRef(null);
  const ringRef   = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const ring   = ringRef.current;
    if (!cursor || !ring) return;
    let rx = 0, ry = 0, id;

    const move = (e) => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top  = e.clientY + 'px';
      cancelAnimationFrame(id);
      id = requestAnimationFrame(() => {
        rx += (e.clientX - rx) * 0.14;
        ry += (e.clientY - ry) * 0.14;
        ring.style.left = rx + 'px';
        ring.style.top  = ry + 'px';
      });
    };
    const over = (e) => {
      if (e.target.closest('a,button,[data-hover]')) {
        cursor.classList.add('hovered');
        ring.classList.add('hovered');
      }
    };
    const out = () => { cursor.classList.remove('hovered'); ring.classList.remove('hovered'); };

    document.addEventListener('mousemove', move);
    document.addEventListener('mouseover', over);
    document.addEventListener('mouseout',  out);
    return () => {
      document.removeEventListener('mousemove', move);
      document.removeEventListener('mouseover', over);
      document.removeEventListener('mouseout',  out);
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className="cursor" />
      <div ref={ringRef}   className="cursor-ring" />
    </>
  );
}
